<ngx-spinner type="ball-atom"></ngx-spinner>
<div class="component-container">
  <div class="button-group">
    <button mat-raised-button color="primary" (click)="onCreateCountry()">
      <mat-icon>add</mat-icon>
      Add Country
    </button>
  </div>
  <app-lookup-table
      [items]="countries"
      [columns]="countriesColumns"
      [enableMatching]="enableMatching"
      (itemClick)="onItemSelected($event)"
      (editClick)="onEditCountry($event)"
      (deleteClick)="onDeleteCountry($event)"
      (itemSave)="onItemSave($event)"
      (itemAdd)="onItemAdd($event)">
    </app-lookup-table>
</div>
